import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=99c4d8d4&scoped=true&"
import script from "./Connection.vue?vue&type=script&lang=js&"
export * from "./Connection.vue?vue&type=script&lang=js&"
import style0 from "./Connection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Connection.vue?vue&type=style&index=1&id=99c4d8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c4d8d4",
  null
  
)

export default component.exports